// extracted by mini-css-extract-plugin
export default {"container":"AuthContainer__container___PbSnO","containerLarge":"AuthContainer__containerLarge___mjN5L","contactText":"AuthContainer__contactText___4rlcC"};